import React from "react";
import PropTypes from "prop-types";
import { Divider, H6 } from "orcs-design-system";
import { toUpper } from "lodash";
import { PanelLine } from "src/components/OrgChart/components/OrgChartPanel/panels/shared/PanelLine";

export const PanelSection = ({
  name,
  canEdit,
  canSave,
  isEditing,
  isSaving,
  onEdit,
  onSave,
  onCancel,
}) => {
  return (
    <>
      <Divider dash />
      <PanelLine
        canEdit={canEdit}
        canSave={canSave}
        isEditing={isEditing}
        isSaving={isSaving}
        onEdit={onEdit}
        onSave={onSave}
        onCancel={onCancel}
      >
        <H6 weight="bold" color="greyDark">
          {toUpper(name)}
        </H6>
      </PanelLine>
    </>
  );
};

PanelSection.propTypes = {
  name: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  canSave: PropTypes.bool,
  isEditing: PropTypes.bool,
  isSaving: PropTypes.bool,
  onEdit: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
};
